import {Add, Remove, CenterFocusStrong} from '@mui/icons-material'
import {Box, IconButton, Tooltip, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {AREA_DASHBOARD_WIDGET_NAMESPACE} from '../../consts'

type MapZoomControlsProps = {
  zoom: number
  onZoomIn: () => void
  onZoomOut: () => void
  onReset: () => void
  minZoom?: number
  maxZoom?: number
}

export const MapZoomControls = ({
  zoom,
  onZoomIn,
  onZoomOut,
  onReset,
  minZoom = 1,
  maxZoom = 4
}: MapZoomControlsProps) => {
  const {t} = useTranslation(AREA_DASHBOARD_WIDGET_NAMESPACE)
  const zoomPercent = Math.round(zoom * 100)

  return (
    <Box
      sx={(theme) => ({
        position: 'absolute',
        bottom: 16,
        left: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 1,
        boxShadow: 2,
        p: 0.5,
        zIndex: 10
      })}
    >
      <Tooltip title={t('map.zoomIn')} placement="right">
        <span>
          <IconButton
            size="small"
            onClick={onZoomIn}
            disabled={zoom >= maxZoom}
            sx={(theme) => ({color: theme.palette.text.primary})}
          >
            <Add fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Typography
        variant="caption"
        sx={(theme) => ({
          textAlign: 'center',
          color: theme.palette.text.secondary
        })}
      >
        {zoomPercent}%
      </Typography>

      <Tooltip title={t('map.zoomOut')} placement="right">
        <span>
          <IconButton
            size="small"
            onClick={onZoomOut}
            disabled={zoom <= minZoom}
            sx={(theme) => ({color: theme.palette.text.primary})}
          >
            <Remove fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={t('map.resetView')} placement="right">
        <span>
          <IconButton
            size="small"
            onClick={onReset}
            disabled={zoom === 1}
            sx={(theme) => ({color: theme.palette.text.primary})}
          >
            <CenterFocusStrong fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}
